import { render } from "./AstrocartographyReportsDashboard.vue?vue&type=template&id=3ed31189&scoped=true"
import script from "./AstrocartographyReportsDashboard.vue?vue&type=script&lang=js"
export * from "./AstrocartographyReportsDashboard.vue?vue&type=script&lang=js"

import "./AstrocartographyReportsDashboard.vue?vue&type=style&index=0&id=3ed31189&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed31189"]])

export default __exports__